export default {"src":"/_next/static/media/integration-with-cloud-security-solution.ee103585.svg","height":306,"width":306,"blurWidth":0,"blurHeight":0};